import React from 'react'
import CssBaseline from '@material-ui/core/CssBaseline'
import { StylesProvider, MuiThemeProvider } from '@material-ui/core/styles'
import { SnackbarProvider } from 'notistack'
import { LoadingProvider } from '../../components/atoms/Loading'
import EditModelDialog from '../../components/molecules/EditModelDialog'
import { EditModelDialogProvider } from '../../components/molecules/EditModelDialog/hooks'
import PaperDetailsModal from '../../components/molecules/PaperDetailsModal'
import { PaperDetailsModalProvider } from '../../components/molecules/PaperDetailsModal/hooks'
import SubmitModelDialog from '../../components/molecules/SubmitModelDialog'
import { SubmitModelDialogProvider } from '../../components/molecules/SubmitModelDialog/hooks'
import Login, { LoginProvider } from '../../components/organisms/Login'
import { PaperProvider } from '../../components/organisms/Paper'
import { CprmSearchProvider } from '../../components/pages/Search/hooks'
import { FirebaseProvider } from '../../libraries/Firebase'
import { customTheme } from '../../libraries/MaterialUI'
import { useCreateSystem } from '../../system'
import { GraphqlRequestContextProvider } from './GraphqlRequestContext'

const Component: React.FC = ({ children }) => {
  const { graphqlClient } = useCreateSystem()
  return (
    <StylesProvider injectFirst>
      <MuiThemeProvider theme={customTheme}>
        <CssBaseline />
        <LoadingProvider>
          <SnackbarProvider>
            <FirebaseProvider>
              <GraphqlRequestContextProvider graphqlClient={{ backend: graphqlClient }}>
                <PaperProvider>
                  <LoginProvider>
                    <Login />
                    <SubmitModelDialogProvider>
                      <EditModelDialogProvider>
                        <PaperDetailsModalProvider>
                          <CprmSearchProvider>
                            <PaperDetailsModal />
                            <SubmitModelDialog />
                            <EditModelDialog />
                            {children}
                          </CprmSearchProvider>
                        </PaperDetailsModalProvider>
                      </EditModelDialogProvider>
                    </SubmitModelDialogProvider>
                  </LoginProvider>
                </PaperProvider>
              </GraphqlRequestContextProvider>
            </FirebaseProvider>
          </SnackbarProvider>
        </LoadingProvider>
      </MuiThemeProvider>
    </StylesProvider>
  )
}

export default Component
